import { primaryIndexName } from "./searchClient";
import { SearchPageProps } from "../../components/pages/SearchPage/SearchPage";

export const pageIndexName = (searchPageProps: SearchPageProps) => {
  const { isProfilePage, isConciergePage } = searchPageProps;

  if (isProfilePage) {
    return `${primaryIndexName}_profile_sort`;
  }

  if (isConciergePage) {
    return `${primaryIndexName}_concierge_sort`;
  }

  return primaryIndexName;
};

export const sortSettings = [
  { label: "Most relevant", index: primaryIndexName, route: "", legacyRoute: "" },
  {
    label: "Price: high to low",
    index: `${primaryIndexName}_price_desc`,
    route: "-price",
    legacyRoute: "-price_aud",
  },
  {
    label: "Price: low to high",
    index: `${primaryIndexName}_price_asc`,
    route: "price",
    legacyRoute: "price_aud",
  },
  {
    label: "Newest to oldest",
    index: `${primaryIndexName}_date_desc`,
    route: "newest",
    legacyRoute: "-published_at",
  },
  {
    label: "Oldest to newest",
    index: `${primaryIndexName}_date_asc`,
    route: "oldest",
    legacyRoute: "published_at",
  },
  {
    label: "Best deals",
    index: `${primaryIndexName}_best_deals`,
    route: "deals",
    legacyRoute: "-price_reduced_percentage",
  },
];

export const sortByItems = sortSettings.map(({ label, index }) => ({
  label,
  value: index,
}));

export const sortRouteToStateHash = sortSettings.reduce((acc, { index, route, legacyRoute }) => {
  acc[route] = index;
  acc[legacyRoute] = index;
  return acc;
}, {});

export const sortStateToRouteHash = sortSettings.reduce((acc, { index, route }) => {
  acc[index] = route;
  return acc;
}, {});
